<template>
    <uiModal :title="docName" icon="fal fa-file-word" :name="name" size="lg">
        <div class="doc-container">
            <iframe :id="idIframe" :src="docUrl" frameborder="0"/>
            <div class="hide"/>
        </div>
    </uiModal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'

	export default {
		name: 'ui-doc-preview',
		components: { uiModal },

		props: {
			/**
			 * Use para definir qual documento deve ser renderizado
			 */
			url: {
				type: String,
				required: false,
			},
			/**
			 * Use para definir qual sera o nome exibido no modal
			 */
			docName: {
				type: String,
				required: false,
			},
			/**
			 * Use para definir qual o name do modal
			 */
			name: {
				type: String,
				required: false,
			},
		},

		data() {
			return {
				docUrl: `https://view.officeapps.live.com/op/embed.aspx?src=${this.url}`,
				idIframe: 'doc-preview' + this._uid,
				open: false,
			}
		},

		watch: {
			/**
			 * Recarrega o Iframe quando a url do contrato é alterada
			 */
			url: function () {
				this.open = false
				this.docUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${this.url}`
				this.open = true
			},
		},

		mounted() {
			/**
			 * Fica ouvindo quando o modal é aberto ou fechado
			 */
			this.$root.$on('modal-open-' + this.name, () => {
				this.open = true
			})
			this.$root.$on('modal-close-' + this.name, () => {
				this.open = false
			})
		},
		beforeDestroy() {
			this.$root.$off('modal-open-' + this.name)
			this.$root.$off('modal-close-' + this.name)
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
